import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingAboutWithFooterPetitPrinceRoot = styled("section")(() => {
  return css`
    background: radial-gradient(
      89.73% 46.53% at 64.69% 55.84%,
      #38557b 0%,
      #162740 100%
    );
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    padding-top: 120px;
    padding-bottom: 130px;
    position: relative;

    @media ${responsiveMap.mobile} {
      padding-top: 77px;
      padding-bottom: 515px;
    }

    .landing-about-with-footer-petit-prince__container {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 40px;
      max-width: 1440px;
      margin: 0 auto;
      padding-inline: 48px;

      @media ${responsiveMap.mobile} {
        gap: 24px;
        padding-inline: 24px;
      }
    }
  `;
});
